import moment from 'moment'

export default function(angularModule) {
  angularModule.controller(
    'listingManagementRecentLocationsCtrl',
    (
      $scope,
      $http,
      pagingService
    ) => {

      $scope.locations = []
      $scope.locationsPaged = pagingService.createPagingData($scope.locations, 15, 'dateAdded', true)

      $scope.dateOptions = [
        {name: "Last 24 Hours", startDate: moment().subtract(1, 'd').format("YYYY-MM-DD")},
        {name: "Last 7 Days", startDate: moment().subtract(7, 'd').format("YYYY-MM-DD")},
        {name: "This Month", startDate: moment().startOf('month').format("YYYY-MM-DD")},
        {name: "Last 31 Days", startDate: moment().subtract(31, 'd').format("YYYY-MM-DD")},
        {name: "Last 3 Months", startDate: moment().subtract(3, 'month').format("YYYY-MM-DD")},
      ]

      $scope.searchConfig = {
        locationQuery: "",
        createdAfter: $scope.dateOptions[0].startDate
      }

      $scope.search = () => {

        const params = {
          createdAfter: $scope.searchConfig.createdAfter,
          generalTextMatch: $scope.searchConfig.locationQuery === "" ? undefined : $scope.searchConfig.locationQuery,
        }

        $http.get("/listingManagement/locations", {params})
          .then(resp => {
            $scope.locations = resp.data
            $scope.locationsPaged = pagingService.createPagingData($scope.locations, 15, 'dateAdded', true)
          })
      }

      $scope.search()
    })
}
